<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
  import addClientEvent from "./api/addClientEvent";
  export default {
    name: 'App',
    created () {
      // addClientEvent.setStorageParam()
    },
    mounted () {
      // setInterval(e => {
      //   addClientEvent.recordEventInfo()
      // }, 1000 * 10)
    }
  }
</script>

<style scoped>
  @import "./assets/sass/normal.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue